(function(){
  async function bvAdd(variantId, qty, el){
    var ev = await import('@shopify/events');
    var C = ev.CartLinesUpdateEvent;
    var d = C.createPromise();
    (el||document).dispatchEvent(new C({action:'add',context:'product',lines:[{merchandiseId:String(variantId),quantity:qty||1}],promise:d.promise}));
    var fd = new FormData(); fd.append('id', variantId); fd.append('quantity', qty||1);
    var ids=[]; document.querySelectorAll('cart-items-component').forEach(function(c){ if(c.dataset.sectionId) ids.push(c.dataset.sectionId) });
    if(ids.length) fd.append('sections', ids.join(','));
    var res = await fetch((window.Theme&&Theme.routes&&Theme.routes.cart_add_url)||'/cart/add', {method:'POST', body:fd, headers:{'X-Requested-With':'XMLHttpRequest', Accept:'application/javascript'}}).then(function(r){return r.json()});
    var cart = await fetch('/cart.js').then(function(r){return r.json()});
    d.resolve({cart:C.createCartFromAjaxResponse(cart), detail:{items:cart.items, source:'bv-quickadd', sourceId:'bv-quickadd', itemCount:qty||1, productId:res.product_id, sections:res.sections, didError:!!res.status}});
    if(res.status) throw new Error(res.description||res.message||'Error');
    return res;
  }
  window.bvAdd = bvAdd;
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-bv-quickadd]'); if(!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]'); var id = f.querySelector('[name=id]').value;
    if(!id){ return; }
    var txt = btn.innerHTML; btn.disabled = true; btn.classList.add('is-loading');
    bvAdd(id, 1, f).then(function(){ btn.innerHTML = 'Añadido ✓'; setTimeout(function(){ btn.innerHTML = txt; btn.disabled=false; btn.classList.remove('is-loading') }, 1800) })
      .catch(function(err){ btn.innerHTML = 'Sin stock'; setTimeout(function(){ btn.innerHTML = txt; btn.disabled=false; btn.classList.remove('is-loading') }, 2200) });
  });
})();